export { Affix } from 'antd'
export type { AffixProps } from 'antd'
